// Global Instructions Rule Applied!
import { MENU_ITEM_KEY_FUNDRAISING_PIPELINE } from '../../state_manager/globals.ts'

export type ViewTaskConfig = {
  showTasks: boolean
  maxVisible?: number
  showCompleted?: boolean
}

export const VIEW_TASK_CONFIG: Record<string, ViewTaskConfig> = {
  [MENU_ITEM_KEY_FUNDRAISING_PIPELINE]: { showTasks: true, maxVisible: 3, showCompleted: true },
  'deal-pipeline': { showTasks: true, maxVisible: 3, showCompleted: true },
  fundraising: { showTasks: true, maxVisible: 3, showCompleted: true },
  deals: { showTasks: true, maxVisible: 3, showCompleted: true },
  companies: { showTasks: true, maxVisible: 3, showCompleted: true }
}
